import { BASE_URL } from './chat'

const VOICE_NOTE_URL = `${BASE_URL}/voice-note`

/**
 * Sends a recorded voice note. The backend transcribes it and returns a text reply.
 */
export async function sendVoiceNote({ audioBase64, mimeType, history }) {
  const response = await fetch(VOICE_NOTE_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify({
      audio_base64: audioBase64,
      mime_type: mimeType,
      history: history || []
    })
  })

  const text = await response.text()
  let body = {}
  if (text) {
    try {
      body = JSON.parse(text)
    } catch (parseError) {
      body = { error: text || parseError.message }
    }
  }

  if (!response.ok) {
    throw new Error(body.error || `Voice note failed (${response.status})`)
  }

  return body
}
